import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  Container,
  Card,
  Table,
  Badge,
  Spinner,
  Form,
  Button,
  Modal,
  Dropdown
} from "react-bootstrap";
import Swal from "sweetalert2";
import InformacionUsuario from "../modales/InformacionUsuario";
import AvatarCentrado from "../modales/AvatarCentrado";
import FotoINE from "../modales/FotoINE";
import SeleccionarRol from "../modales/SeleccionarRol";
import RazonBaja from "../modales/RazonBaja";
import ReactivacionWizard from "../modales/ReactivacionWizard";

import {API_BASE} from "../../services/apirest";

const ultimosRoles = [
  { id: 8, nombre:  "VENDEDOR (ACTIVE DIRECTORY/SIEBEL TELCOM)" },
  { id: 9, nombre:  "VENDEDOR / INSTALADOR (TOA)" },
  { id: 10, nombre: "SUPERVISOR" },
  { id: 11, nombre: "ADMINISTRATIVO" },
];

const TRANSICIONES = Object.freeze({
  8: [9, 10, 11],
  9: [10, 11],
  10: [11],
  11: [],
});

export default function PlantillaPorStatus() {
  const [perfil, setPerfil]       = useState(null);
  const [list, setList]           = useState(null);
  const [statusFilter, setStatusFilter] = useState("Activo"); // por defecto activo
  const [userRedFilter, setUserRedFilter]     = useState("");
  const [cvvenFilter, setCvvenFilter] = useState("");
  const [selected, setSelected]         = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showBajaModal, setShowBajaModal] = useState(false);
  const [showReactivarModal, setShowReactivarModal] = useState(false);
  const [showModificarModal, setShowModificarModal] = useState(false);
  const [rolSeleccionado, setRolSeleccionado] = useState(null);
  const isSupervisor = perfil?.rol_id === 3;
  const [reason, setReason] = useState({ type: "", text: ""  });
  const [bajaLoading, setBajaLoading] = useState(false);
  // — arriba de everything else —
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [bodegas, setBodegas] = useState([]);
  const [bodegasLoading, setBodegasLoading] = useState(false);
  const [bodegaSearch, setBodegaSearch] = useState("");
  const [showBodegaDropdown, setShowBodegaDropdown] = useState(false);
  const [bodegaIdSel, setBodegaIdSel] = useState("");

  const total = Array.isArray(list) ? list.length : 0;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  const pageData = useMemo(() => {
    if (!Array.isArray(list)) return [];
    const start = (page - 1) * pageSize;
    return list.slice(start, start + pageSize);
  }, [list, page, pageSize]);


  const headers = useMemo(() => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  }), []);

  const getVal = (obj, keys) =>
  keys.map(k => obj?.[k]).find(v => typeof v === "string" && v.trim() !== "");

const getBodegaParts = (b) => {
  const bodega = getVal(b, ["BODEGA","bodega"]);
  const almacen = getVal(b, ["ALMACEN","almacen"]);
  const region = getVal(b, ["REGION","region"]);
  const direccion = getVal(b, ["DIRECCION","direccion"]);
  return { bodega, almacen, region, direccion };
};

const bodegaFullLabel = (b) => {
  const { bodega, almacen, region } = getBodegaParts(b);
  return [bodega, almacen, region].filter(Boolean).join(" — ");
};

const sortedBodegas = useMemo(() => {
  return [...bodegas].sort((a, b) => {
    const AREG = (a.REGION || a.region || "").localeCompare(b.REGION || b.region || "");
    if (AREG !== 0) return AREG;
    const ACOD = (a.BODEGA || a.bodega || a.ALMACEN || a.almacen || "")
      .localeCompare(b.BODEGA || b.bodega || b.ALMACEN || b.almacen || "");
    return ACOD;
  });
}, [bodegas]);

const selectedBodegaObj = useMemo(
  () => bodegas.find(b => String(b.id_bodega) === String(bodegaIdSel)),
  [bodegas, bodegaIdSel]
);

  useEffect(() => {
    fetch(`${API_BASE}/perfil.php`, { headers })
        .then(r => r.json())
        .then(d => d.status === "success" && setPerfil(d.result.user))
        .catch(console.error);
  }, [headers]);

  const isStageMostrable = (v) => {
    if (v == null) return true;                   // NULL / undefined
    const s = String(v).trim().toLowerCase();     // "" también permitido
    return s === "" || s === "vistodistribuidor" || s === "vistodistribuidormod";
  };

  useEffect(() => {
  // Limpiar selección si cambia el rol o el registro
  setBodegaIdSel("");

  // Solo si el nuevo rol es 9 y hay un seleccionado con distribuidor_id
  if (!rolSeleccionado || rolSeleccionado.id !== 9 || !selected?.distribuidor_id) {
    setBodegas([]);
    return;
  }

  (async () => {
    try {
      setBodegasLoading(true);
      const res = await fetch(
        `${API_BASE}/bodegas.php?distribuidor_id=${selected.distribuidor_id}`,
        { headers } // ya trae Authorization Bearer
      );
      const json = await res.json();
      const arr = json?.result?.bodegas || [];
      setBodegas(arr);
    } catch (e) {
      console.error("Error cargando bodegas:", e);
      setBodegas([]);
      Swal.fire("Sin bodegas", "No fue posible cargar bodegas del distribuidor.", "warning");
    } finally {
      setBodegasLoading(false);
    }
  })();
}, [rolSeleccionado, selected, headers]);



  const load = useCallback(async () => {
    if (!perfil) return;
    try {
      // 1) Traemos la lista según statusFilter (activo o inactivo)
      const res = await fetch(`${API_BASE}/solicitudes.php?status=${encodeURIComponent(statusFilter)}`, { headers });
      if (!res.ok) {
        const txt = await res.text();
        throw new Error(`HTTP ${res.status} - ${txt}`);
      }
      const json = await res.json();
      let datos = (json.result && json.result.solicitudes) ? json.result.solicitudes : [];
      // 0) Rechazo: solo excluye en "Activo" (para "Inactivo" no te estorba)
       if (statusFilter === "Activo") {
           const rechazo = (v) => String(v ?? "").trim().length > 0;
           datos = datos.filter(s => !rechazo(s.situacion_rechazo));
         }
      // 2) Estado según el tab
       if (statusFilter === "Activo") {
           const permitidos = ["Completado", "Visto"];
           datos = datos
               .filter(s => permitidos.includes(String(s.Estado || "").trim()))
               .filter(s =>
                   isStageMostrable(s.baja_stage) &&
                   isStageMostrable(s.reactivacion_stage) &&
                   isStageMostrable(s.modificaciones_stage)
               );

         } else if (statusFilter === "Inactivo") {
           // aquí sí exiges VISTO para inactivos:
               datos = datos.filter(s => String(s.Estado || "").trim() === "Visto");
         }
      // 2.1) Si estamos en "inactivo", quitamos los Visto sin foto_id y con situacion_rechazo
      if (statusFilter.toLowerCase() === "inactivo") {
        datos = datos.filter(s =>
            !(s.Estado === "Visto" && !s.foto_id && !!s.situacion_rechazo)
        );
      }
      // 3) Si soy supervisor (rol 3), solo mis supervisados
      if (perfil.rol_id === 3) {
        const first = (...cands) => cands.find(v => v !== undefined && v !== null && v !== "");
        const norm = (v) => (v ? String(v).trim().toLowerCase() : "");
        const mySup = norm(first(perfil.correo_supervisor, perfil.Usuario, perfil.usuario, perfil.email));
        if (!mySup) {
          datos = [];
        } else {
          datos = datos.filter(s => {
            const sup = norm(first(s.correo_supervisor, s.supervisor_correo, s.supervisor_email));
            return sup === mySup;
          });
        }
      }
      if (perfil.rol_id === 4) {
        // Para que el distribuidor vea a toda su plantilla, 
        // filtramos por su ID de distribuidor en lugar de quién creó el registro.
        datos = datos.filter(s => Number(s.distribuidor_id) === Number(perfil.distribuidor_id));
      }

      // 4) Filtros de búsqueda por nombre y RFC
      if (userRedFilter.trim()) {
        const term = userRedFilter.toLowerCase();
        datos = datos.filter(s => (s.usuario_red || "").toLowerCase().includes(term));
      }
      if (cvvenFilter.trim()) {
        const term = cvvenFilter.toLowerCase();
        datos = datos.filter(s => ((s.cvven ?? s.ccven) || "").toLowerCase().includes(term));
      }

      setList(datos);
    } catch (err) {
      console.error(err);
      setList([]);
    }
  },  [perfil, statusFilter, userRedFilter, cvvenFilter, headers]);

  useEffect(() => {
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, [load]);


const rolActual = Number(selected?.rol_id);
const rolesDisponibles = useMemo(() => {
  const ids = TRANSICIONES[rolActual] ?? [];
  // Genera objetos {id, nombre} en el mismo formato de ultimosRoles
  return ids.map(id => ultimosRoles.find(r => r.id === id)).filter(Boolean);
  }, [rolActual]);

// Limpia la selección al cambiar el usuario o al abrir/cerrar el modal
useEffect(() => {
  setRolSeleccionado(null);
}, [rolActual, showModificarModal]);

  const exportToExcel = () => {
    if (!Array.isArray(list) || list.length === 0) return;

    // 1) Cabeceras, incluyendo FECHA ALTA y FECHA BAJA
    const headersCsv = [
      "REGION","SUBREGION","HUB","PLAZA","NOMBRE DE VENDEDOR","DISTRIBUIDOR",
      "RAZON SOCIAL","KAM","STATUS","JORNADA","SUPERVISOR INTERNO (izzi)",
      "GERENTE INTERNO (IZZI)","CANAL DE DISTRIBUCION","TIPO DE USUARIO",
      "CLASIFICACION DE CLAVE","RFC VENDEDOR","USUARIO DE RED","CVVEN",
      "NO. DE EMPLEADO","SALES FORCE (SKY)","FECHA ALTA","FECHA BAJA",
      "SUPERVISOR DISTRIBUIDOR","RFC Supervisor Distribuidor",
      "CLAVE SUPERVISOR","STATUS" //,"REGION_ID"
    ];

    // 2) Filas: extraemos s.Fecha (alta) y s.fecha_baja si existe
    const rows = list.map(s => [
      s.region_nombre||"",
      s.subregion||"",
      s.region_hub||"",
      s.region_plaza||"",
      `${s.nombre_usuario} ${s.apellido_paterno} ${s.apellido_materno}`.trim(),
      s.distribuidor_nombre||"",
      s.distribuidor_rs||"",
      s.distribuidor_kam||"",
      s.status||"",
      "COMPLETA",
      s.supervisor||"",
      s.gerente_nombre||"",
       s.clasificacion_clave||s.uso_clave_id||"",
      s.tipo_usuario||s.rol_id||"",
      s.clasificacion_clave||s.uso_clave_id||"",
      s.rfc||"",
      s.usuario_red||"",
      s.cvven ?? s.ccven ?? "",
      s.numero_vendedor||"",
      s.usuario_red||"",
      // Fecha alta (campo Fecha)
      new Date(s.Fecha).toLocaleString(),
      // Fecha baja (campo fecha_baja) — formateada si existe
      s.fecha_baja
          ? new Date(s.fecha_baja).toLocaleString()
          : "",
      s.supervisor_distribuidor||"",
      s.rfc_supervisor_distribuidor||"",
      s.clave_supervisor||"",
      s.status||"",
      //s.region_id||""
    ]);

    // 3) Montamos CSV y forzamos BOM para Excel
    const csv = [
      headersCsv.join(","),
      ...rows.map(r =>
          r
              .map(cell => `"${String(cell).replace(/"/g,'""')}"`)
              .join(",")
      )
    ].join("\r\n");

    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href     = url;
    a.download = `solicitudes_${statusFilter}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const isPlaceholder = (v) => {
    if (v == null) return true;
    const s = String(v).trim();
    if (s === "") return true;
    const lower = s.toLowerCase();
    if (["null", "undefined", "n/a", "na"].includes(lower)) return false;
    // solo guiones/dashes: - (ASCII), – (en dash), — (em dash)
    if (/^[-\u2013\u2014]+$/.test(s)) return true;
    return false;
  };
  const mark = (v) => (isPlaceholder(v) ? "❌" : "✅");


  const handleOpenBaja = (s) => {
    setSelected(s);
    setReason({ type: "", text: "" });
    setShowBajaModal(true);
  };
  const handleOpenReactivar = (s) => {
    setSelected(s);
    setShowReactivarModal(true);
  };

 const handleOpenModificar = (s) => {
  if (!s) return;
  if (Number(s.rol_id) === 11) {
    Swal.fire("No permitido", "ADMINISTRATIVO no admite cambios de puesto.", "info");
    return;
  }
  setSelected(s);
  setShowModificarModal(true);
};

  useEffect(() => {
    setPage(1);
  }, [statusFilter, userRedFilter, cvvenFilter, perfil]);

  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [totalPages, page]);

  const handleCloseBaja = () => {
    setShowBajaModal(false);
    // no limpias selected porque lo usás también para detalle si querés
  };

  const handleCloseModificar = () => {
    setShowModificarModal(false);
    // no limpias selected porque lo usás también para detalle
  };

const handleConfirmBaja = async () => {
  const { type, text } = reason;

  if (!type) {
    return Swal.fire("Error", "Selecciona un motivo de baja", "warning");
  }

  const razon =
    type === "Mala práctica" || type === "Otro"
      ? (text || "").trim()
      : type;

  if (!razon) {
    return Swal.fire("Error", "Debes explicar la razón", "warning");
  }

  try {
    setBajaLoading(true); // 🔁 empieza loading

    const payload = {
      action: isSupervisor ? "solicitar_baja_supervisor" : "solicitar_baja",
      SolicitudId: selected.SolicitudId,
      // manda alias para compatibilidad backend
      razon_baja: razon,
      razon_de_baja: razon,
      motivo_baja: razon,
    };

    const res = await fetch(`${API_BASE}/solicitudes.php`, {
      method: "PUT",
      headers,
      body: JSON.stringify(payload),
    });
    const json = await res.json();

    if (json.status === "success" || json.status === "ok") {
      Swal.fire("Procesado", "Baja en progreso.", "success");
      await load();
      setShowBajaModal(false);
      setList(prev =>
        prev.filter(s => s.SolicitudId !== selected.SolicitudId)
      );
      setSelected(null);
      await load(); // si quieres revalidar con backend
    } else {
      throw new Error(json.result?.error_msg || "Error en la respuesta");
    }
  } catch (err) {
    Swal.fire("Error", err.message || "Falló la petición", "error");
  } finally {
    setBajaLoading(false); // 🔁 termina loading
  }
};



  const handleConfirmReactivacion = async ({ telco, red, toa }) => {
    if (!telco && !toa && !red) {
      return Swal.fire('Error','Selecciona al menos una opción','warning');
    }

    try {
      const payload = {
        action: 'solicitar_reactivacion',
        SolicitudId: selected.SolicitudId,
        status: 'Activo',
        Estado: 'Pendiente',
        reactivacion_stage: 'SolicitudReactivacion',
        reactivar_telco: telco ? 1 : 0,
        reactivar_toa:   toa   ? 1 : 0,
        reactivar_red:   red   ? 1 : 0,
        ...(telco && { red_siebel_telcom: null }),
        ...(toa   && { fgu_toa:           null }),
        ...(red   && { usuario_red:       null }),
      };

      const res = await fetch(`${API_BASE}/solicitudes.php`, {
        method: 'PUT',
        headers,
        body: JSON.stringify(payload),
      });
      const json = await res.json();

      if (json.status === 'success' || json.status === 'ok') {
        Swal.fire('¡LISTO!', 'Solicitud de reactivación enviada.', 'success');
        await load();
        // Refresca la UI usando **los argumentos**, no el estado.
        setList(prev => prev.map(s =>
            s.SolicitudId === selected.SolicitudId
                ? {
                  ...s,
                  Estado: 'Pendiente',
                  reactivacion_stage: 'SolicitudReactivacion',
                  ...(telco ? { red_siebel_telcom: null } : {}),
                  ...(toa   ? { fgu_toa:           null } : {}),
                  ...(red   ? { usuario_red:       null } : {}),
                }
                : s
        ));
        setSelected(prev => prev ? {
          ...prev,
          Estado: 'Pendiente',
          reactivacion_stage: 'SolicitudReactivacion',
          ...(telco ? { red_siebel_telcom: null } : {}),
          ...(toa   ? { fgu_toa:           null } : {}),
          ...(red   ? { usuario_red:       null } : {}),
        } : prev);
      } else {
        throw new Error(json.result?.error_msg ?? 'Error en la respuesta');
      }
    } catch (err) {
      Swal.fire('Error', err.message || 'Falló la petición', 'error');
    }
  };

const handleConfirmModificacion = async () => {
  if (!rolSeleccionado) {
    return Swal.fire("Atención", "Selecciona el nuevo puesto.", "warning");
  }
  const permitidos = TRANSICIONES[Number(selected?.rol_id)] ?? [];
  if (!permitidos.includes(rolSeleccionado.id)) {
    return Swal.fire("No permitido", "Ese cambio no está permitido para el puesto actual.", "error");
  }

  // Validación específica para rol 9
  if (rolSeleccionado.id === 9 && !bodegaIdSel) {
    return Swal.fire("Falta bodega", "Selecciona una bodega para el rol 9.", "warning");
  }

  try {
    const payload = {
      action: isSupervisor ? "solicitar_modificacion_supervisor" : "solicitar_modificacion",
      SolicitudId: selected.SolicitudId,
      new_rol_id: rolSeleccionado.id,
      ...(rolSeleccionado.id === 9 && bodegaIdSel ? { bodega_id: Number(bodegaIdSel) } : {})
    };

    const res = await fetch(`${API_BASE}/solicitudes.php`, {
      method: "PUT",
      headers,
      body: JSON.stringify(payload),
    });
    const json = await res.json();
    if (json.status === "success" || json.status === "ok") {
      Swal.fire("¡LISTO!", "Solicitud de modificación enviada.", "success");

      await load();
      setList(prev =>
        prev.map(s =>
          s.SolicitudId === selected.SolicitudId
            ? {
                ...s,
                modificaciones_data: {
                  new_rol_id: rolSeleccionado.id,
                  ...(rolSeleccionado.id === 9 ? { bodega_id: bodegaIdSel } : {}),
                },
                ...(rolSeleccionado.id === 9
                  ? {
                      bodega_id: bodegaIdSel,
                      bodega_nombre: selectedBodegaObj?.BODEGA || selectedBodegaObj?.bodega,
                      bodega_region: selectedBodegaObj?.REGION || selectedBodegaObj?.region,
                      bodega_almacen: selectedBodegaObj?.ALMACEN || selectedBodegaObj?.almacen,
                      bodega_direccion: selectedBodegaObj?.DIRECCION || selectedBodegaObj?.direccion,
                    }
                  : {}
                ),
              }
            : s
        )
      );
      handleCloseModificar();
    } else {
      throw new Error(json.result?.error_msg);
    }
  } catch (err) {
    Swal.fire("Error", err.message || "Algo falló", "error");
  } finally {
  }
};




  

  if (list === null) {
    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
          <Spinner animation="border"/>
        </Container>
    );
  }

  return (
    <div className="app-container">
      <Container className="my-5">
        <Card className="shadow-sm">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">PLANTILLA</h5>
            <Badge pill bg={list.length ? "primary" : "secondary"}>
              {list.length}
            </Badge>
          </Card.Header>
          <Card.Body>
            <div className="mb-3 d-flex align-items-end flex-wrap">
              {/* ← Solo dos opciones */}
              <Form.Group controlId="statusFilter" className="me-3 mb-2">
                <Form.Label>Filtrar por Status:</Form.Label>
                <Form.Select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="Activo">Activos</option>
                  <option value="Inactivo">Inactivos</option>
                </Form.Select>
              </Form.Group>
              {/* filtros por usuario_red y ccven */}
              <Form.Group controlId="userRedFilter" className="me-3 mb-2">
                <Form.Label>Filtrar por Usuario de Red:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Usuario de Red..."
                  value={userRedFilter}
                  onChange={(e) => setUserRedFilter(e.target.value)}
                />
              </Form.Group>
            <Form.Group controlId="cvvenFilter" className="me-3 mb-2">
              <Form.Label>CVVEN:</Form.Label>
              <Form.Control
                type="text"
                placeholder="CVVEN..."
                value={cvvenFilter}
                onChange={(e) => setCvvenFilter(e.target.value)}
              />
            </Form.Group>
              <div className="ms-auto d-flex align-items-end gap-2 mb-2">
                <Form.Group>
                  <Form.Label className="mb-0 small">Filas por página</Form.Label>
                  <Form.Select
                      size="sm"
                      value={pageSize}
                      onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }}
                      style={{ width: 120 }}
                  >
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Select>
                </Form.Group>

                <div className="small text-muted">
                  {total > 0
                      ? <>Mostrando {Math.min((page - 1) * pageSize + 1, total)}–{Math.min(page * pageSize, total)} de {total}</>
                      : <>Sin resultados</>}
                </div>
              </div>
              <Button
                variant="success"
                onClick={exportToExcel}
                className="mb-2"
              >
                Exportar
              </Button>
            </div>

            <Table responsive hover striped className="align-middle">
              <thead className="table-light">
                <tr>
                  <th>Distribuidor</th>
                  <th>HUB</th>
                  <th>Nombre</th>
                  <th>CVVEN</th>
                  <th>Usuario de Red</th>
                  <th>RFC</th>
                  <th>Puesto Actual</th>
                  <th>Supervisor Interno IZZI</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {list.length === 0 ? (
                  <tr>
                    <td colSpan={8}>
                      <div className="d-flex justify-content-between align-items-center mt-3"> hay solicitudes.
                      <small className="text-muted d-block">
                        filtro={statusFilter} / status={selected?.status} /
                        Estado={selected?.Estado}
                      </small>
                        </div>
                    </td>
                  </tr>
                ) : (
                    pageData.map((s) => (
                    <tr
                      key={s.SolicitudId}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSelected(s);
                        setShowDetailModal(true);
                      }}
                    >
                      <td>{s.distribuidor_nombre}</td>
                      <td>{s.region_hub}</td>
                      <td>{`${s.nombre_usuario} ${s.apellido_paterno} ${s.apellido_materno}`}</td>
                      <td>{s.cvven ?? s.ccven}</td>
                      <td>{s.usuario_red}</td>
                      <td>{s.rfc}</td>
                      <td>{s.tipo_usuario}</td>
                      <td>{s.supervisor}</td>
                      <td>
                        {statusFilter?.toLowerCase() === "activo" &&
                          (s?.Estado || "").trim().toLowerCase() ===
                            "visto" && (
                            <div className="d-flex flex-column gap-2">
                              <Button
                                size="sm"
                                variant="danger"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOpenBaja(s);
                                }}
                              >
                                Solicitar baja
                              </Button>
                              <Button
                                size="sm"
                                variant="success"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOpenModificar(s);
                                }}
                              >
                                Solicitar modificación
                              </Button>
                              <Button
                                size="sm"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOpenReactivar(s);
                                }}
                              >
                                Solicitar reactivación
                              </Button>
                            </div>
                          )}
                        {statusFilter?.toLowerCase() === "inactivo" && (
                          <Button
                            size="sm"
                            variant="primary"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenReactivar(s);
                            }}
                          >
                            Reactivar
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>

            </Table>
            {total > pageSize && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="small text-muted">
                    Página {page} de {totalPages}
                  </div>
                  <div className="d-flex gap-2">
                    <Button size="sm" variant="outline-secondary" onClick={() => setPage(1)} disabled={page === 1}>
                      « Primero
                    </Button>
                    <Button size="sm" variant="outline-secondary" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>
                      ‹ Anterior
                    </Button>
                    <Button size="sm" variant="outline-secondary" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>
                      Siguiente ›
                    </Button>
                    <Button size="sm" variant="outline-secondary" onClick={() => setPage(totalPages)} disabled={page === totalPages}>
                      Último »
                    </Button>
                  </div>
                </div>
            )}
            <Modal
              show={showDetailModal}
              onHide={() => setShowDetailModal(false)}
              size="lg"
              centered
              dialogClassName="modal-100w"
              style={{ zIndex: 11000 }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Detalle Solicitud</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {selected && (
                    <>
                      {/* Avatar centrado */}
                      <AvatarCentrado src={selected?.foto_url} alt="Foto del vendedor" />
                      {/*Cards reutilizables */}

                      {/* 1) Distribuidor */}
                      <InformacionUsuario
                          user={selected}
                          title="Distribuidor"
                          cols={2}
                          fields={[
                            { key: "distribuidor_nombre", label: "Distribuidor" },
                            { key: "distribuidor_rs",     label: "Razón Social" },
                          ]}
                      />

                      {/* 3) Datos del usuario */}
                      <InformacionUsuario
                          user={selected}
                          title="Datos del usuario"
                          cols={3}
                          fields={[
                            { key: "usuario", label: "Email", render: (u) => u?.usuario || u?.Usuario || "—" },
                            {
                              key: "nombre_completo",
                              label: "Nombre completo",
                              render: (u) =>
                                  [u?.nombre_usuario, u?.apellido_paterno, u?.apellido_materno]
                                      .filter(Boolean)
                                      .join(" "),
                            },
                            { key: "telefono",       label: "Teléfono" },
                            { key: "Fecha",          label: "Fecha Ingreso", render: (u) => u?.Fecha ? new Date(u.Fecha).toLocaleDateString("es-MX") : "—" },
                            { key: "rfc",            label: "RFC", render: (u) => (u?.rfc || "—").toUpperCase() },
                            { key: "numero_vendedor",label: "Número Empleado" },
                          ]}
                      />

                      {/* 4) Puesto y credenciales */}
                      <InformacionUsuario
                          user={selected}
                          title="Puesto y credenciales"
                          cols={3}
                          hideEmpty={false}
                          fields={[
                            { key: "rol_id",           label: "Puesto Actual", render: (u) => (ultimosRoles.find(r => r.id === u?.rol_id)?.nombre) || "—" },
                            { key: "supervisor",       label: "Supervisor Interno IZZI" },
                            { key: "usuario_red",      label: "Usuario red",      render: (u) => (u?.usuario_red || "—").toUpperCase() },
                            { key: "cvven",            label: "CVVEN",   render: (u) => u?.cvven || u?.cvven || "—" },
                            {key: "fgu_toa", label: "Usuario TOA", render: (u) => {if (u?.rol_id !== 9) return ""; return mark(u?.fgu_toa) ? `✅` : "❌";},},
                            {key: "fgu_pi", label: "PI", render: (u) => {if (u?.rol_id !== 9) return ""; return mark(u?.fgu_pi) ? `✅` : "❌";},},
                          ]}
                      />

                        {/* 5) Bodega (SOLO si hay datos) */}
                    {(
                      selected?.bodega_distribuidor ||
                      selected?.bodega_almacen ||
                      selected?.bodega_nombre ||
                      selected?.bodega_region ||
                      selected?.bodega_direccion
                    ) && (
                      <InformacionUsuario
                        user={selected}
                        title="Bodega"
                        cols={2}
                        hideEmpty={true}
                        fields={[
                          { key: "bodega_distribuidor", label: "Distribuidor" },
                          { key: "bodega_almacen",      label: "Almacén" },
                          { key: "bodega_nombre",       label: "Bodega" },
                          { key: "bodega_region",       label: "Región" },
                          { key: "bodega_direccion",    label: "Dirección" },
                        ]}
                      />
                    )}
                      {/* 5) Ubicación */}
                      <InformacionUsuario
                          user={selected}
                          title="Ubicación"
                          cols={3}
                          fields={[
                            { key: "region_hub",    label: "HUB" },
                            { key: "region_nombre", label: "Región" },
                            { key: "region_plaza",  label: "Plaza" },
                          ]}
                      />
                      {/* 6) Datos extra para inactivos */}
                      {statusFilter?.toLowerCase() === "inactivo" && (
                          <InformacionUsuario
                              user={selected}
                              title="Baja"
                              cols={3}
                              hideEmpty={false}
                              headerStyle={{ backgroundColor: '#dc3545', color: '#fff' }}
                              fields={[
                                { key: "fecha_baja", label: "Fecha Baja",  render: (u) => u?.fecha_baja ? new Date(u.fecha_baja).toLocaleDateString("es-MX") : "—" },
                                { key: "folio_baja", label: "Folio Baja",  render: (u) => u?.folio_baja || "—" },
                                { key: "razon_baja", label: "Razón de Baja", render: (u) => u?.razon_baja || "—" },
                                { key: "fgu_usuario",label: "FGU Usuario", render: (u) => u?.fgu_usuario || "—" },
                              ]}
                          />
                      )}
                      {/* 7) Motivo de rechazo */}
                      {selected?.situacion_rechazo && (
                          <InformacionUsuario
                              user={selected}
                              title="Motivo de rechazo"
                              cols={1}
                              hideEmpty={false}
                              fields={[
                                { key: "situacion_rechazo", label: "Detalle", render: (u) => u?.situacion_rechazo || "—" },
                              ]}
                          />
                      )}
                      {/*Foto INE */}
                      <hr />
                      <FotoINE url={selected?.ine_url} />
                    </>
                )}
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-between">
                <div>
                  {selected?.Estado === "En proceso" && (
                    <Button
                      variant="success"
                      onClick={() => {
                        setShowDetailModal(false);
                      }}
                    >
                      Aprobar
                    </Button>
                  )}
                </div>
                <Button
                  variant="secondary"
                  onClick={() => setShowDetailModal(false)}
                >
                  Cerrar
                </Button>
              </Modal.Footer>
            </Modal>
            <ReactivacionWizard
                open={showReactivarModal}
                selected={selected}
                onClose={() => setShowReactivarModal(false)}
                initialSelections={{ telco: false, red: false, toa: false }}
                onConfirm={({ telco, red, toa }) => {

                  // usa directamente los argumentos
                  handleConfirmReactivacion({ telco, red, toa });
                }}
            />

            {/* Modal de modificacion */}
            <Modal
              show={showModificarModal}
              onHide={handleCloseModificar}
              size="lg"
              centered
              style={{ zIndex: 11000 }}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Modificación de Solicitud #{selected?.SolicitudId}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {selected && (
                    <>
                      {/* Avatar centrado */}
                      <AvatarCentrado src={selected?.foto_url} alt="Foto del vendedor" />
                      {/* Selector de nuevo puesto (dropdown con búsqueda) */}
                      {rolesDisponibles.length === 0 ? (
                        <div className="alert alert-info mb-3">
                          Este puesto no permite realizar cambios.
                        </div>
                      ) : (
                        <SeleccionarRol
                          roles={rolesDisponibles}        // [{id, nombre}] -> mostrará el texto de "nombre"
                          value={rolSeleccionado}         // objeto seleccionado {id, nombre}
                          onChange={setRolSeleccionado}
                          className="mb-3"
                          label="Seleccione cambio de puesto"
                        />
)}
{rolSeleccionado?.id === 9 && (
  <>
    <div className="mb-2 fw-semibold">Seleccione bodega </div>

    <div className="mb-3">
      <Form.Label>Bodega</Form.Label>
      <Dropdown
        show={showBodegaDropdown}
        onToggle={(isOpen) => setShowBodegaDropdown(isOpen)}
      >
        <Dropdown.Toggle
          variant="outline-secondary"
          className="w-100 text-start"
          id="dropdown-bodega-mod"
          disabled={bodegasLoading}
        >
          {selectedBodegaObj
            ? bodegaFullLabel(selectedBodegaObj)
            : (bodegasLoading ? "Cargando bodegas..." : "Seleccione bodega...")}
        </Dropdown.Toggle>

        <Dropdown.Menu className="w-100 p-2" style={{ maxHeight: 300, overflowY: "auto" }}>
          <Form.Control
            autoFocus
            type="text"
            placeholder="Buscar bodega..."
            value={bodegaSearch}
            onChange={(e) => setBodegaSearch(e.target.value)}
            className="mb-2"
          />

          {sortedBodegas
            .filter(b => {
              const { bodega, almacen, region, direccion } = getBodegaParts(b);
              const haystack = `${bodega||""} ${almacen||""} ${region||""} ${direccion||""}`.toLowerCase();
              return haystack.includes(bodegaSearch.toLowerCase());
            })
            .map(b => {
              const { bodega, almacen, region } = getBodegaParts(b);
              return (
                <Dropdown.Item
                  key={b.id_bodega}
                  onClick={() => {
                    setBodegaIdSel(String(b.id_bodega));
                    setShowBodegaDropdown(false);
                  }}
                >
                  <div className="fw-semibold">{bodega || "(Sin nombre de bodega)"}</div>
                  <div className="small text-muted">
                    {almacen ? `Almacén: ${almacen}` : "Almacén: —"}
                    {region ? ` · Región: ${region}` : " · Región: —"}
                  </div>
                </Dropdown.Item>
              );
            })
          }

          {!bodegasLoading && sortedBodegas.length === 0 && (
            <div className="text-center text-muted p-2">Sin resultados</div>
          )}
        </Dropdown.Menu>
      </Dropdown>

      {selectedBodegaObj && (
        <Form.Text className="text-muted">
          {selectedBodegaObj.DIRECCION || selectedBodegaObj.direccion || ""}
        </Form.Text>
      )}
    </div>
  </>
)}

                      {/* Puesto actual */}
                      <InformacionUsuario
                          user={selected}
                          title="Puesto actual"
                          cols={2}
                          fields={[
                            {
                              key: "rol_id",
                              label: "Puesto actual",
                              render: (u) => ultimosRoles.find((r) => r.id === u?.rol_id)?.nombre || "-",
                            },
                          ]}
                      />
                      {/* Datos del agente */}
                      <InformacionUsuario
                          user={selected}
                          title="Datos del agente"
                          cols={3}
                          fields={[
                            {
                              key: "nombre_completo",
                              label: "Nombre",
                              render: (u) =>
                                  [u?.nombre_usuario, u?.apellido_paterno, u?.apellido_materno]
                                      .filter(Boolean)
                                      .join(" ") || "—",
                            },
                            { key: "telefono", label: "Teléfono" },
                            {
                              key: "Fecha",
                              label: "Fecha Alta",
                              render: (u) => (u?.Fecha ? new Date(u.Fecha).toLocaleDateString("es-MX") : "—"),
                            },
                            { key: "rfc", label: "RFC", render: (u) => (u?.rfc || "—").toUpperCase() },
                            { key: "usuario_red", label: "Usuario Red", render: (u) => (u?.usuario_red || "—").toUpperCase() },
                            { key: "cvven", label: "CVVEN", render: (u) => u?.cvven ?? u?.ccven ?? "—" },
                            {key: "fgu_toa", label: "Usuario TOA", render: (u) => (u?.rol_id === 9 ? mark(u?.fgu_toa, true) : "")},
                            {key: "fgu_pi", label: "PI", render: (u) => (u?.rol_id === 9 ? mark(u?.fgu_pi, true) : "")},
                            { key: "Usuario", label: "Correo", render: (u) => u?.Usuario || u?.usuario || "—" },
                          ]}
                      />
                    </>
                )}
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-end gap-2">
                <Button variant="secondary" onClick={handleCloseModificar}>
                  Cerrar
                </Button>
                <Button
                  variant="success"
                  onClick={handleConfirmModificacion}
                  disabled={
                    !rolSeleccionado ||
                    rolesDisponibles.length === 0 ||
                    (rolSeleccionado.id === 9 && !bodegaIdSel)
                  }
                >
                  Aceptar
                </Button>
              </Modal.Footer>
            </Modal>
            {/* Modal de baja */}
            <Modal
              show={showBajaModal}
              onHide={handleCloseBaja}
              size="lg"
              centered
              style={{ zIndex: 11000 }}
            >
               <Modal.Header closeButton>
                <Modal.Title>Solicitud de Baja  </Modal.Title>
              </Modal.Header>

              <Modal.Body>
                {selected && (
                    <>
                      {/* Avatar centrado */}
                      <AvatarCentrado src={selected?.foto_url} alt="Foto del vendedor" />

                      {/* Motivo de rechazo previo (si aplica) */}
                      {selected?.situacion_rechazo && (
                          <InformacionUsuario
                              user={selected}
                              title="Motivo de Rechazo"
                              cols={1}
                              hideEmpty={false}
                              fields={[
                                { key: "situacion_rechazo", label: "Detalle", render: (u) => u?.situacion_rechazo || "—" },
                              ]}
                          />
                      )}

                      {/* Selector de motivo de baja */}
                      <RazonBaja
                          value={reason}
                          onChange={setReason}
                          className="mb-2"
                      />

                      {/* Puesto actual */}
                      <InformacionUsuario
                          user={selected}
                          title="Puesto actual"
                          cols={2}
                          fields={[
                            {
                              key: "rol_id",
                              label: "Puesto",
                              render: (u) => ultimosRoles.find((r) => r.id === u?.rol_id)?.nombre || "-",
                            },
                          ]}
                      />

                      {/* Datos del agente */}
                      <InformacionUsuario
                          user={selected}
                          title="Datos del agente"
                          cols={3}
                          fields={[
                            { key: "Usuario",          label: "Email", render: (u) => u?.Usuario || u?.usuario || "—" },
                            {
                              key: "nombre_completo",
                              label: "Nombre",
                              render: (u) =>
                                  [u?.nombre_usuario, u?.apellido_paterno, u?.apellido_materno].filter(Boolean).join(" ") || "—",
                            },
                            { key: "telefono",         label: "Teléfono" },
                            {
                              key: "Fecha",
                              label: "Fecha",
                              render: (u) => (u?.Fecha ? new Date(u.Fecha).toLocaleDateString("es-MX") : "—"),
                            },
                            { key: "rfc",              label: "RFC", render: (u) => (u?.rfc || "—").toUpperCase() },
                            { key: "cvven", label: "CVVEN", render: (u) => u?.cvven ?? u?.cvven ?? "—" },
                            { key: "usuario_red",      label: "Usuario Red", render: (u) => (u?.usuario_red || "—").toUpperCase() },
                            {key: "fgu_toa", label: "Usuario TOA", render: (u) => (u?.rol_id === 9 ? mark(u?.fgu_toa, true) : "")},
                            {key: "fgu_pi", label: "PI", render: (u) => (u?.rol_id === 9 ? mark(u?.fgu_pi, true) : "")},
                          ]}
                      />
                    </>
                )}
              </Modal.Body>
               <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseBaja}>
                  Cerrar
                </Button>
                <Button
                  variant="danger"
                  onClick={handleConfirmBaja}
                  disabled={
                    bajaLoading ||
                    !reason.type ||
                    ((reason.type === "Mala práctica" || reason.type === "Otro") &&
                      !reason.text?.trim())
                  }
                >
                  {bajaLoading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Enviando...
                    </>
                  ) : (
                    "Ejecutar"
                  )}
                </Button>
              </Modal.Footer>
            </Modal>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}